module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"title":"撰寫其他評論","expected_reward":"最高可獲得 {0}"}}')
  delete Component.options._Ctor
}
